import React, { Fragment } from "react";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import * as Yup from "yup";
import Button from "../../components/button";

const AddInternalNotesForPatientInstantHush = props => {
  const formik = useFormik({
    initialValues: {
      message: props.internalNotes ? props.internalNotes : ""
    },
    validationSchema: Yup.object({
      message: Yup.string()
        .required("Please enter the message")
        .min(2, "Message must be of atleat 10 characters")
    }),
    onSubmit: values => {
      props.onFormSubmit(values.message);
    }
  });

  return (
    <Fragment>
      <p>
        Notes <span className="error">*</span>
      </p>
      <form className="d-flex flex-column" onSubmit={formik.handleSubmit}>
        <TextField
          name="message"
          className="w-100"
          rows={"5"}
          multiline
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.message}
          error={formik.touched.message && formik.errors.message ? true : false}
          helperText={
            formik.touched.message && formik.errors.message
              ? formik.errors.message
              : ""
          }
        />
        <br />
        <p className="mb-0 d-flex justify-content-center">
          <Button title="Submit" type="submit" />
          <Button
            title="Close"
            type="button"
            className="ml-2"
            clickEvent={props.cancelEvent}
          />
        </p>
      </form>
    </Fragment>
  );
};

export default AddInternalNotesForPatientInstantHush;

AddInternalNotesForPatientInstantHush.propTypes = {
  onFormSubmit: PropTypes.func.isRequired,
  cancelEvent: PropTypes.func.isRequired
};
